import { useState } from "react";
import { LogResponseArchive } from "../../axios";
import { DateUtils } from "../../utils/DateUtils";
import { DbUtils } from "../../utils/DbUtils";
import { ErrorUtils } from "../../utils/ErrorUtils";
import { HtmlUtils } from "../../utils/HtmlUtils";
import ArchiveEdit from "./ArchiveEdit";

interface Props {
	/** 検索履歴Id */
	searchId: string,

	/** ログ送信履歴一覧 */
	logArchives: LogResponseArchive[],
};

/**
 * ログ一覧用コンポーネント
 * 
 * @returns 
 */
export default function ArchiveList(props: Props): JSX.Element {

	/**
	 * ダウンロードボタンクリック時イベント
	 */
	const handleCommit = async () => {
		try {
			await DbUtils.getDownloadApi().createDownloadLog({
				search_id: props.searchId
			});
				alert('ダウンロードファイル作成依頼を行いました。\n作成終了までしばらくお待ちください。');
		} catch (error) {
			ErrorUtils.alert(error);
		}
	};

	/** 1行描画する。 */
	const renderRow = (logArchives: LogResponseArchive) => {
		return (
			<tr>
				{/* 作成日 */}
				<td>{DateUtils.formatDate(logArchives.create_date)}</td>
				{/* ファイル名 */}
				<td style={{ wordBreak: 'break-all',whiteSpace: "pre-wrap" }}>{logArchives.file_name_line_break}<br /></td>
			</tr>
		);
	};

	// 描画する
	return (
		<>
			<hr />
			<div className="control-group">
				<div className="controls">
					<button className="btn btn-default btn-primary pull-center" type="button" onClick={handleCommit}>ダウンロードファイル作成</button>
				</div>
			</div>
			<div style={{ width: '100%' }}>
				<table width="100%" className="dlist" id="table01">
					<tbody>
						<tr>
							<th>作成日</th>
							<th>ファイル名</th>
						</tr>
						{props.logArchives.map(logArchives => renderRow(logArchives))}
					</tbody>
				</table>
			</div>
		</>
	);
}